// DELETE a record. Resolves { ok: true } or { ok: false, message } where the
// message says why, so the caller can show it inside the page.
export async function deleteRecord(url) {
  try {
    const response = await fetch(url, { method: 'DELETE' });
    if (response.ok) return { ok: true };
    let message = `Delete failed (${response.status})`;
    try {
      message = (await response.json()).error || message;
    } catch (e) {
      // response had no JSON body
    }
    return { ok: false, message };
  } catch (error) {
    console.error('Error deleting:', error);
    return {
      ok: false,
      message: 'Could not reach the server. If you were signed out, reload the page and sign in again.'
    };
  }
}
